import React from "react";
import { resultState } from "../atoms/result";
import HtmlHeader from "../components/HTMLHeader";
import { useRecoilValue } from "recoil";

const HtmlHeaderContainer = () => {
  const result_data = useRecoilValue(resultState);

  return <>{result_data && <HtmlHeader />}</>;
};

export default HtmlHeaderContainer;
